import React from "react";
import { useServer } from "../../services/api-client/useServer";
import { useSnackbar } from "../../services/api-client/useSnackbar";
import CardPanel from "../../components/DesignSystem/Output/CardPanel";

const DashboardPage: React.FC = () => {
	const server = useServer();
	const { showSnack } = useSnackbar();
	const { jobs, isLoading, error } = server.getJobs();

	//console.log("DashboardPage render, jobs count:", jobs?.length);

	if (error) {
		console.log("DashboardPage error:", error);
		showSnack("NotifyNetworkError", "light");
	}

	if (isLoading) {
		return <p>Loading</p>;
	}

	return <CardPanel jobs={jobs} />;
};

export default DashboardPage;
